// Language.tsx
// 言語選択UI
import './Language.css';
import React, { useState } from 'react';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { setLanguage, LANGUAGE } from '../../redux/userSlice';

const Language: React.FC = () => {

    const dispatch:AppDispatch = useDispatch();
    const [selectMode, setSelectMode] = useState<boolean>(false);

    // 選択中の言語
    const language = useSelector((state: RootState) => state.user.language);

    // 選択モードへ
    const handleButtonSelectMode = () => {
        setSelectMode(true);
    }
    // 言語選択時の処理
    const handleButtonClick = (selectLanguage:LANGUAGE) => {
        setSelectMode(false);
        dispatch(setLanguage(selectLanguage));
    }

    if (!selectMode) {

        return (
            <div className="language-container">
                <div className="language_icon_item language-icon">
                    <img 
                        src={`images/${language}.svg`}
                        className="language-image" alt="team" 
                        onClick={handleButtonSelectMode}
                    />
                </div>
            </div>
        )

    } else {

        return (
            <div className="language-container">
                <div className="language_icon_item language-btn">
                    <img
                        src="images/ja.svg"
                        className="language-image" alt="team" 
                        onClick={() => handleButtonClick("ja")}
                    />
                    <img 
                        src={language==="ja" ? "images/ja.svg" : "images/ja_disabled.svg"}
                        className="language-image" alt="team" 
                        onClick={() => handleButtonClick("ja")}
                    />
                </div>
                <div className="language_icon_item language-btn">
                    <img
                        src="images/vi.svg"
                        className="language-image" alt="team" 
                        onClick={() => handleButtonClick("vi")}
                    />
                    <img
                        src={language==="vi" ? "images/vi.svg" : "images/vi_disabled.svg"} 
                        className="language-image" alt="team" 
                        onClick={() => handleButtonClick("vi")}
                    />
                </div>
                <div className="language_icon_item language-btn">
                    <img
                        src="images/zh.svg"
                        className="language-image" alt="team" 
                        onClick={() => handleButtonClick("zh")}
                    />
                    <img 
                        src={language==="zh" ? "images/zh.svg" : "images/zh_disabled.svg"} 
                        className="language-image" alt="team" 
                        onClick={() => handleButtonClick("zh")}
                    />
                </div>
                <div className="language_icon_item language-btn">
                    <img
                        src="images/id.svg"
                        className="language-image" alt="team" 
                        onClick={() => handleButtonClick("id")}
                    />
                    <img 
                        src={language==="id" ? "images/id.svg" : "images/id_disabled.svg"} 
                        className="language-image" alt="team" 
                        onClick={() => handleButtonClick("id")}
                    />
                </div>
                <div className="language_icon_item language-btn">
                    <img
                        src="images/en.svg"
                        className="language-image" alt="team" 
                        onClick={() => handleButtonClick("en")}
                    />
                    <img
                        src={language==="en" ? "images/en.svg" : "images/en_disabled.svg"} 
                        className="language-image" alt="team" 
                         onClick={() => handleButtonClick("en")}
                    />
                </div>
            </div>
        )
    }
}

export default Language;
